module.exports = __webpack_public_path__ + "images/eswe_small3ab8a02eb42767ba0baa9a43ddde76a4.png";